import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { HTML_LANG } from './i18n'
import reportWebVitals from './reportWebVitals'
import { FollowProvider } from './State/Follow'
import { UiProvider } from './State/Ui'
import './Styles/index.scss'
import { applyAdConsent } from './Utils/consent'

document.documentElement.lang = HTML_LANG
applyAdConsent() // before any ad slot asks for an ad

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <UiProvider>
      <FollowProvider>
        <App />
      </FollowProvider>
    </UiProvider>
  </React.StrictMode>
)

reportWebVitals()
